// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b78dc648]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.redirect-config[data-v-b78dc648]{overflow:hidden}.redirect-config .el-select[data-v-b78dc648]{width:130px;margin-right:10px}.redirect-config .el-input[data-v-b78dc648]{width:calc(100% - 140px)}.redirect-config .el-button[data-v-b78dc648]{float:right}.el-card+.el-card[data-v-b78dc648]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
